import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/huBei/user.png'
import _imports_1 from '@/assets/image/huBei/phone.png'
import _imports_2 from '@/assets/image/huBei/no.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0bd44201")

_pushScopeId("data-v-0bd44201")
const _hoisted_1 = { class: "user-info-container" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  style: {"width":"0.38rem","height":"0.38rem"}
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "",
  style: {"width":"0.26rem","height":"0.38rem"}
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "",
  style: {"width":"0.32rem","height":"0.3rem"}
}, null, -1)
const _hoisted_7 = { class: "submit-btn" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 提交 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_cell_group = _resolveComponent("van-cell-group")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_form = _resolveComponent("van-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: _ctx.banner,
        alt: ""
      }, null, 8, ["src"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
        default: _withId(() => [
          _createVNode(_component_van_cell_group, { inset: "" }, {
            default: _withId(() => [
              _createVNode(_component_van_field, {
                class: "user",
                modelValue: _ctx.form.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
                placeholder: "姓名",
                rules: [{ required: true, message: '姓名不能为空' }]
              }, {
                "left-icon": _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.form.phone,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.phone = $event)),
                type: "tel",
                placeholder: "手机号",
                rules: [
              { required: true, message: '手机号不能为空' },
              { validator: _ctx.validatorTel }
            ]
              }, {
                "left-icon": _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["modelValue", "rules"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.form.code,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.code = $event)),
                placeholder: "工号",
                rules: [{ required: true, message: '工号不能为空' }]
              }, {
                "left-icon": _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_van_button, {
              round: "",
              block: "",
              type: "primary",
              "native-type": "submit",
              color: "#FF931F"
            }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
})